/* eslint-disable no-template-curly-in-string */
import { setLocale } from 'yup';
import { TFunction } from 'i18next';

export function buildYupLocale(_: unknown, t: TFunction): void {
  const locale = {
    mixed: {
      default: t('YUP_VALIDATION_MIXED_DEFAULT'),
      required: t('YUP_VALIDATION_MIXED_REQUIRED'),
      oneOf: t('YUP_VALIDATION_MIXED_ONE_OF'),
      notOneOf: t('YUP_VALIDATION_MIXED_NOT_ONE_OF')
    },
    string: {
      length: t('YUP_VALIDATION_STRING_LENGTH'),
      min: t('YUP_VALIDATION_STRING_MIN'),
      max: t('YUP_VALIDATION_STRING_MAX'),
      email: t('YUP_VALIDATION_STRING_EMAIL'),
      url: t('YUP_VALIDATION_STRING_URL'),
      trim: t('YUP_VALIDATION_STRING_TRIM'),
      lowercase: t('YUP_VALIDATION_STRING_LOWERCASE'),
      uppercase: t('YUP_VALIDATION_STRING_UPPERCASE')
    },
    number: {
      min: t('YUP_VALIDATION_NUMBER_MIN'),
      max: t('YUP_VALIDATION_NUMBER_MAX'),
      lessThan: t('YUP_VALIDATION_NUMBER_LESS_THAN'),
      moreThan: t('YUP_VALIDATION_NUMBER_MORE_THAN'),
      positive: t('YUP_VALIDATION_NUMBER_POSITIVE'),
      negative: t('YUP_VALIDATION_NUMBER_NEGATIVE'),
      integer: t('YUP_VALIDATION_NUMBER_INTEGER')
    },
    date: {
      min: t('YUP_VALIDATION_DATE_MIN'),
      max: t('YUP_VALIDATION_DATE_MAX')
    },
    array: {
      min: t('YUP_VALIDATION_ARRAY_MIN'),
      max: t('YUP_VALIDATION_ARRAY_MAX')
    }
  };

  setLocale(locale);
}
